import $ from 'jquery';
import {isEmpty,locale,acc,root,get_first_tabindex,loopFocus} from '../Helpers';

export default  class Feedback {

    constructor() {
    }
     close(){
         this.elem.hide()
         get_first_tabindex(root().elem).focus()

    };
    open(){
        this.elem.show()
        this.form.focus()
    };
    send(data){
        /*todo loader?*/
        const url  =  acc('feedback_action')
        $.post(url,data)
            .done((res) => {
                console.log(res)
                if (res.success) {
                    console.log(res.data);
                    this.clear()
                    this.output.html(res.data)
                    setTimeout(()=>{
                        this.close()
                    },2000)
                }
                else{
                    this.output.html(res.data)
                }
            })
            .fail((e) => {
                console.log(e)
            });
    };
    clear(){
        const fields = ['acc_feedback_name','acc_feedback_mail','acc_feedback_msg','acc_feedback_pageurl','acc_feedback_antispam']
        fields.forEach((f)=>{
            $('#'+f).val('')
        })
        this.output.html('')
    }

    render(){
        if(!acc('showFeedbackForm')){return null}

        this.form = $(`<form action="${acc('feedback_action')}" enctype="multipart/form-data" tabindex="0"  id="acc-theform" method="POST"  aria-describedby="${locale('send_feedback')}">
                            <p>${locale('acc_feedback_description')}</p>
                                <label for="acc_feedback_name">
                                    <apan>${locale('full_name')}</apan>
                                    <input tabindex="0" aria-required="true" type="text" name="acc_feedback_name" id="acc_feedback_name" required>
                                </label>
                                <label for="acc_feedback_name">
                                    <apan>${locale('email')}</apan>
                                    <input tabindex="0" aria-required="true" type="email" name="acc_feedback_mail" id="acc_feedback_mail" required>
                                </label>
                                <label for="acc_feedback_msg">
                                    <apan>${locale('feedback_msg')}</apan>
                                    <textarea tabindex="0" name="acc_feedback_msg" aria-required="true"  id="acc_feedback_msg" cols="20" rows="10"  required></textarea>
                                </label>
                                <input type="hidden"  aria-hidden="true" name="acc_feedback_pageurl" id="acc_feedback_pageurl" value="${acc('current_page_url')}">
                                <p class="antispam" aria-hidden="true">
                                    <input name="acc_feedback_antispam" id="acc_feedback_antispam" type="text" value="">
                                </p>
                                <input tabindex="0" type="submit" value="${locale('send')}">
                            </form>`);
        this.elem = $(`<section id="acc-contactform" role="form" tabindex="0">
                        <div id="acc-contactform-header">
                            <h4>${locale('send_feedback')}</h4>
                            <button id="acc-contactform-close" class="acc-close-btn"  aria-label="${locale('close_feedback')}"></button>
                        </div>
                        <div id="acc-contactform-content">
                            <div class="flachbg"></div>
                         </div>
                    </section>`);

        this.output = $('<div id="acc_feedback_output">')
        this.elem.find('#acc-contactform-content').append(this.form,this.output)

        this.form.submit((e)=>{
            e.preventDefault()
            const data = this.form.serializeArray()
            this.send(data)
        })

        this.elem.hide();
        loopFocus(this.elem)
        return this.elem
    }

}
